var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"courseG flex-column-center"},[_c('div',{staticClass:"courseGImg"},[_c('ul',{staticClass:"ulImg"},_vm._l((_vm.itemData.tips),function(item,index){return _c('li',{key:index},[_c('img',{attrs:{"src":item.image}}),_c('span',[_vm._v(_vm._s(item.content))])])}),0)]),_c('div',{staticClass:"courseGBottom"})])
}
var staticRenderFns = []

export { render, staticRenderFns }